export default {
  text: {
    marginTop: '0.7em',
    marginBottom: '0.7em'
  }
}
